import { AndroidInterface } from "@/apps/credit-line/services/android.service";
declare const Android: AndroidInterface;

export const isAndroid = (): boolean => {
  return !(typeof Android === typeof undefined);
};
